import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Container, 
  Grid, 
  Stack 
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FileText, Shield, Zap } from 'lucide-react';

function Landing() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary' }}>
      <Container maxWidth="lg">
        {/* Header */}
        <Box sx={{ py: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            Global TI Devis et Gestion de Projets Applicatifs
          </Typography>
          <Button variant="outlined" color="primary" onClick={() => navigate('/login')}>
            Accéder au portail
          </Button>
        </Box>

        {/* Hero Section */}
        <Box sx={{ py: { xs: 8, md: 15 }, textAlign: 'center' }}>
          <Typography variant="h1" sx={{ 
            fontSize: { xs: '2.5rem', md: '4rem' }, 
            fontWeight: 800, 
            mb: 3,
            background: 'linear-gradient(45deg, #00d4aa 30%, #7c3aed 90%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            Digitalisez vos devis applicatifs.
          </Typography>
          <Typography variant="h5" color="text.secondary" sx={{ mb: 6, maxWidth: '800px', mx: 'auto' }}>
            Une plateforme moderne et sécurisée pour gérer vos demandes de projets, 
            suivre l'avancement technique et centraliser vos échanges avec GlobalTI.
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button variant="contained" size="large" onClick={() => navigate('/login')}>
              Commencer maintenant
            </Button>
          </Stack>
        </Box>

        {/* Features */}
        <Grid container spacing={4} sx={{ pb: 10 }}>
          <Grid item xs={12} md={4}>
            <Box sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 4, border: '1px solid rgba(255, 255, 255, 0.06)' }}>
              <Zap size={40} color="#00d4aa" style={{ marginBottom: '20px' }} />
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>Rapidité</Typography>
              <Typography color="text.secondary">
                Créez vos demandes en quelques minutes via notre interface Smart Stepper assistée.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 4, border: '1px solid rgba(255, 255, 255, 0.06)' }}>
              <Shield size={40} color="#00d4aa" style={{ marginBottom: '20px' }} />
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>Sécurité</Typography>
              <Typography color="text.secondary">
                Vos documents et échanges sont protégés par nos standards de sécurité entreprise.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 4, border: '1px solid rgba(255, 255, 255, 0.06)' }}>
              <FileText size={40} color="#00d4aa" style={{ marginBottom: '20px' }} />
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>Transparence</Typography>
              <Typography color="text.secondary">
                Suivez l'état de votre soumission en temps réel, de l'analyse à la mise en production.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Landing;